import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_LiabilityV1GetsafeDe } from '@flows/insurance/schemas'

const liability_drone = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('drones_coverage')]:
        BaseSchema_LiabilityV1GetsafeDe.shape.drones_coverage,
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_liabilityNxt:steps.liability.drone.title',
        },
        infoButton: {
          modalConfiguration: [
            {
              type: 'text',
              text: {
                type: 'translatableText',
                translationKey: 'sharedFlows_liabilityNxt:steps.liability.drone.info.text',
              },
            },
          ],
        },
      },
      {
        type: 'choice',
        name: params.helperFunctions.getParamPath('drones_coverage'),
        options: [
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_liabilityNxt:steps.liability.drone.yes',
            },
            value: true,
          },
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_liabilityNxt:steps.liability.drone.no',
            },
            value: false,
          },
        ],
      },
    ],
    subFlow: params.subFlow,
    nextStep: 'liability_zip',
  }) as const satisfies AnyStepConfiguration

export default liability_drone
